import { TemplatesTable } from '../components/TemplatesTable';
import { templeDataMapper } from '../lib/Template';
import { Box, CircularProgress } from '@mui/material';
import { useTemplates } from '../lib/store/organization/useTemplates';


export const Templates: React.FC = () => {
    const { templates, ready } = useTemplates();

    return (
        <>
            {
                !ready ? (
                    <Box textAlign="center"><CircularProgress sx={{color: '#005e7a'}} /></Box>
                ) :  (
                    <TemplatesTable rows={templeDataMapper(templates || [])} />
                )
            }
        </>
    );
}